import { useQuery } from "@tanstack/react-query";

import { PatientsApi } from "../api/patientsApi";

export const PatientsQueryKeys = {
  all: ["patients"] as const,
  me: () => [...PatientsQueryKeys.all, "me"] as const,
};

export const useCurrentPatientQuery = ({
  isEnabled = true,
}: {
  isEnabled?: boolean;
} = {}) => {
  return useQuery({
    queryKey: PatientsQueryKeys.me(),
    queryFn: () => PatientsApi.getCurrentPatient(),
    staleTime: Infinity,
    enabled: isEnabled,
  });
};
